// extracted by mini-css-extract-plugin
module.exports = {"spin":"LoadingSpinner_spin__1Y8E2","icon-spin":"LoadingSpinner_icon-spin__jnVaN"};